import angularModule from 'Lessons/angularModule/scripts/lessons_module';
import 'ExtensionMethods/array';

angularModule.factory('Lesson.FrameList.Frame.NoInteraction.NoInteractionFrameViewModel', [
    '$injector',

    $injector => {
        const ComponentizedBaseFrameViewModel = $injector.get(
            'Lesson.FrameList.Frame.Componentized.ComponentizedBaseViewModel',
        );

        class NoInteractionFrameViewModel extends ComponentizedBaseFrameViewModel {
            get complete() {
                return true;
            }

            get mainTextComponentViewModel() {
                const mainTextComponent = this.frame.mainTextComponent;
                if (mainTextComponent) {
                    return this.viewModelFor(mainTextComponent);
                }

                return undefined;
            }

            get topContextImageViewModel() {
                const topContextImage = this.frame.topContextImage;
                if (topContextImage) {
                    return this.viewModelFor(topContextImage);
                }

                return undefined;
            }

            get bottomContextImageViewModel() {
                const bottomContextImage = this.frame.bottomContextImage;
                if (bottomContextImage) {
                    return this.viewModelFor(bottomContextImage);
                }

                return undefined;
            }
        }

        return NoInteractionFrameViewModel;
    },
]);
